import { Progress } from "@getgreenline/blaze-ui";

type SpendProgressProps = {
  spendMilliDollars: number;
  budgetMilliDollars: number;
  spendLabel: string;
  budgetLabel: string;
};

export function SpendProgress({
  spendMilliDollars,
  budgetMilliDollars,
  spendLabel,
  budgetLabel,
}: SpendProgressProps) {
  const spend = Math.abs(spendMilliDollars);
  const budget = Math.max(budgetMilliDollars, 0);
  const progress = budget > 0 ? Math.min((spend / budget) * 100, 100) : 0;

  return (
    <div className="tw:space-y-2">
      <div className="tw:flex tw:items-center tw:justify-between tw:gap-3">
        <p className="tw:text-sm tw:text-muted-foreground">Budget spent</p>
        <p className="tw:text-sm tw:font-medium tw:text-foreground">
          {spendLabel} / {budgetLabel}
        </p>
      </div>
      <Progress aria-label="Campaign budget progress" value={progress} />
    </div>
  );
}
